import Card from '@perpay-web/components/base/Card/Card';
import { payCycleTypeToText } from '@perpay-web/fintech/constants/payCycle';
import { formatNumericMonthDay } from '@perpay-web/utils/dateUtils';

import styles from './CardDirectDepositSummaryMetal.scss';

const CardDirectDepositSummaryMetal = ({
    lastUpdatedDate,
    showLastUpdatedDate,
    isCardMinimumPayment,
    cardAmount,
    coreAmount,
    totalAmount,
    payCycleType,
    className,
    showSubHeader,
    headingText,
}) => (
    <Card className={className}>
        <div className={styles.section}>
            <div className={styles.heading}>
                <span className={styles.title}>{headingText}</span>{' '}
                {showLastUpdatedDate && lastUpdatedDate ? (
                    <em className={styles.updated}>
                        Last updated: {formatNumericMonthDay(lastUpdatedDate)}
                    </em>
                ) : null}
            </div>
            {showSubHeader ? <div>Total</div> : null}
            <div className={styles.total}>
                {totalAmount}
                /pay ({payCycleTypeToText(payCycleType)})
            </div>
        </div>
        <div className={styles.section}>
            {isCardMinimumPayment ? (
                <div className={styles.row}>
                    <span className={styles['card-icon']} />
                    <span>
                        Perpay Card - {cardAmount}
                        /pay
                    </span>
                </div>
            ) : null}
            <div className={styles.row}>
                <span className={styles['order-icon']} />
                <span>
                    Marketplace Order - {coreAmount}
                    /pay
                </span>
            </div>
        </div>
    </Card>
);

export default CardDirectDepositSummaryMetal;
